module.exports = __webpack_public_path__ + "img/ch6.b5c69070.jpg";